const registry = new Map();
const listeners = new Set();
function notify() {
    listeners.forEach(l => l());
}
export function registerTabInjection(injection) {
    const normalised = Object.assign(Object.assign({}, injection), { id: injection.id.toLowerCase(), objectType: injection.objectType.toLowerCase() });
    registry.set(normalised.id, normalised);
    notify();
}
export function getAllInjections() {
    return Array.from(registry.values());
}
export function getInjectionsForObjectType(objectType) {
    const key = objectType.toLowerCase();
    return Array.from(registry.values()).filter(c => c.objectType === key);
}
export function unregisterTabInjection(id) {
    const key = id.toLowerCase();
    if (registry.has(key)) {
        registry.delete(key);
        notify();
    }
}
export function onInjectionRegistryChange(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
